import React from 'react';
import './Select.css';

export interface SelectOption {
  value: string;
  label: string;
}

interface SelectProps {
  label?: string;
  value?: string;
  options: SelectOption[];
  onChange?: (value: string) => void;
  id?: string;
  required?: boolean;
  className?: string;
  placeholder?: string;
}

const Select: React.FC<SelectProps> = ({
  label,
  value,
  options,
  onChange,
  id,
  required = false,
  className = '',
  placeholder,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    if (onChange) {
      onChange(e.target.value);
    }
  };

  const selectElement = (
    <select
      id={id}
      className={`select ${className}`}
      value={value}
      onChange={handleChange}
      required={required}
    >
      {placeholder && (
        <option value="" disabled>
          {placeholder}
        </option>
      )}
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );

  if (label) {
    return (
      <div className="select-wrapper">
        <label htmlFor={id}>
          {label}
          {required && <span className="required-asterisk"> *</span>}
        </label>
        {selectElement}
      </div>
    );
  }

  return selectElement;
};

export default Select;
